/**
 * Farbtoene und kleine Helfer des Cockpits — ohne React, damit dashboardUi.tsx
 * nur Komponenten exportiert (Fast Refresh) und die Klassen an einer Stelle stehen.
 */

export type Tone = 'red' | 'amber' | 'emerald' | 'blue' | 'teal' | 'slate';

/** Ausgeschrieben, weil Tailwind seine Klassen aus dem Quelltext liest. */
export const TAG_TONE: Record<Tone, string> = {
    red: 'bg-red-50 text-red-700 border-red-200',
    amber: 'bg-amber-50 text-amber-700 border-amber-200',
    emerald: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    blue: 'bg-blue-50 text-blue-700 border-blue-200',
    teal: 'bg-teal-50 text-teal-700 border-teal-200',
    slate: 'bg-slate-100 text-slate-600 border-slate-200',
};

export const TEXT_TONE: Record<Tone, string> = {
    red: 'text-red-600',
    amber: 'text-amber-600',
    emerald: 'text-emerald-600',
    blue: 'text-blue-600',
    teal: 'text-teal-600',
    slate: 'text-slate-500',
};

export const DOT_TONE: Record<Tone, string> = {
    red: 'bg-red-500',
    amber: 'bg-amber-500',
    emerald: 'bg-emerald-500',
    blue: 'bg-blue-500',
    teal: 'bg-teal-500',
    slate: 'bg-slate-300',
};

/** `prefers-reduced-motion` — fuer Bildlauf und andere Bewegung ausserhalb von CSS. */
export const prefersReducedMotion = (): boolean =>
    typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** Zum Abschnitt rollen; ohne Bewegung, wenn der Nutzer das wuenscht. */
export const scrollToPanel = (el: HTMLElement | null | undefined): void => {
    if (!el) return;
    el.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
};
